import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
  // 左右按钮
  navigation: {
    nextEl: ".banner .swiper-button-next",
    prevEl: ".banner .swiper-button-prev",
  },
  // 只启用一个 pagination（进度条）
  pagination: {
    el: ".banner .swiper-pagination.progress",
    type: "progressbar",
  },
  on: {
    init: function () {
      renderNumbers(this);
    },
    slideChange: function () {
      renderNumbers(this);
    }
  }
}); 

// 自定义 01 02 03
function renderNumbers(swiper) {
  const slides = swiper.wrapperEl.querySelectorAll(
    '.swiper-slide:not(.swiper-slide-duplicate)'
  );

  const total = slides.length;
  const current = swiper.realIndex;

  const format = (n) => (n < 9 ? "0" + (n + 1) : n + 1);

  let html = "";

  for (let i = 0; i < total; i++) {
    html += `<span class="num ${i === current ? "active" : ""}" data-index="${i}">
      ${format(i)}
    </span>`;
  }

  const container = document.querySelector(".banner .swiper-pagination.custom");
  container.innerHTML = html;

  // 点击跳转（关键点）
  container.querySelectorAll(".num").forEach(el => {
    el.onclick = () => {
      swiper.slideToLoop(parseInt(el.dataset.index));
    };
  });
}

var product = new Swiper(".section1 .mySwiper", {
    spaceBetween: '1.16%',
    slidesPerView: 3,
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        spaceBetween: '1.16%',
        slidesPerView: 3,
        slidesPerGroup:3,
      },
      768: {  //当屏幕宽度小于等于768
        spaceBetween: 10,
        slidesPerView: 2,
        slidesPerGroup:2,
      },
      320: {  //当屏幕宽度小于等于320
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup:1,
      }
    },
    navigation: {
        nextEl: ".section1 .swiper-button-next",
        prevEl: ".section1 .swiper-button-prev",
    },

});


$(".value-nav ul li").eq(0).addClass("active");
$(".value-text .text").eq(0).addClass("active");
$(".value-pic .pic").eq(0).addClass("active");
$(".section3 .right .pic").eq(0).addClass("active");
$(".value-nav ul li").hover(function() {
  let index = $(this).index();
  $(this).addClass("active").siblings().removeClass("active");
  $(".value-text .text").eq(index).addClass("active").siblings().removeClass("active");
  $(".value-pic .pic").eq(index).addClass("active").siblings().removeClass("active");
  $(".section3 .right .pic").eq(index).addClass("active").siblings().removeClass("active");
})

var product = new Swiper(".section6 .mySwiper", {
    spaceBetween: '2.03%',
    slidesPerView: 3,
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        spaceBetween: '2.03%',
        slidesPerView: 3,
        slidesPerGroup:3,
      },
      768: {  //当屏幕宽度小于等于768
        spaceBetween: 10,
        slidesPerView: 2,
        slidesPerGroup:2,
      },
      320: {  //当屏幕宽度小于等于320
        spaceBetween: 0,
        slidesPerView: 1,
        slidesPerGroup:1,
      }
    },
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },

});